/* tslint:disable */
 
import { LocalizedValue } from './localized-value';
export class CurrencyDto {
  decimalPlaces: number;
  displaySuffix: LocalizedValue;
  id?: string;
  name: LocalizedValue;
}
